import { render } from "./ViewPracticePhoneticVowel.vue?vue&type=template&id=bafbacca&scoped=true"
import script from "./ViewPracticePhoneticVowel.vue?vue&type=script&lang=js"
export * from "./ViewPracticePhoneticVowel.vue?vue&type=script&lang=js"

import "@/css/views/view-practice-phonetic-vowel.css?vue&type=style&index=0&id=bafbacca&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafbacca"]])

export default __exports__